import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getAuthStatus, login } from "../api/client";
import { queryKeys } from "./queryKeys";

export function useAuthStatus() {
  return useQuery({
    queryKey: queryKeys.authStatus(),
    queryFn: getAuthStatus,
    retry: false,
    staleTime: Infinity,
  });
}

export function useLogin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (password: string) => login(password),
    onSuccess: () => {
      queryClient.setQueryData(queryKeys.authStatus(), {
        required: true,
        authenticated: true,
        mode: "password",
        email: null,
        invited: true,
      });
      void queryClient.invalidateQueries();
    },
  });
}
